import { DataConfiguration, ITimeExtents } from 'interfaces';
import { WIDGET_TYPES } from '/widgets';

export enum SavedViewTypes {
	Explorer = 'explorer',
	Widget = 'widget',
	Dashboard = 'dashboard',
}

// Raw saved data from the explorer widget state
export type ExplorerCard = {
	type: string; // widget string
	endpointQuery: {
		options: any;
		parameters: any; 
	};
	widgetConfiguration?: any;
	metaData?: {
		name: string;
	};
};

// Raw saved explorer view
export type IExplorerView = {
	layout: {
		layoutStyle: {
			key: string;
			cardCount: number;
		};
		cards: ExplorerCard[];
	};
	metaData?: MetaData;
	filters?: {
		timeline: ITimeExtents;
		facets: {
			textFilter: string;
			activeFacets: any;
			activeHierarchicalFacets: any;
		};
	};
	selectedDefinitionName: string;
};

// Adapted from configuration.jsons
export type SavedWidget = {
	type: string; //TODO: put this back as WIDGET_TYPES
	dataConfiguration: DataConfiguration;
	widgetConfiguration: any;
	metaData: MetaData;
};

// As seen in the dashboard configuration.jsons
export interface IDashboardConfig {
	metrics?: {
		selectedDefinition: string;
		age: number;
	};
	cards: SavedWidget[];
	layout?: {
		layoutStyle: {
			key: string;
			cardCount: number;
		};
	};
}

export interface ISavedDashboard extends IDashboardConfig {
	metaData: MetaData;
}

type MetaData = {
	type: SavedViewTypes;
	name: string;
	id: string;
	isFavorite: Boolean;
	owner?: string;
	description?: string;
	lastModified?: Date | null;
}